import {UserType} from "./types";

export const IsInFavorites = (user: UserType, localFavorites: number[], Id: number) => {
    if (user?.Login) {
        return !!user?.Meta?.Favorites?.includes(Id);
    } else {
        return localFavorites.includes(Id);
    }
}